import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import { Stack } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { SquareCard } from '@travelity/ui/square-card';
import type { AvailabilityProduct } from '@travelity/api/services';
import type { PackageBookingFormValues } from '../../package-form.helpers';
import { getEventDurationLabel } from '../../helpers/getEventDurationLabel';

interface PackageBookingDateStartDurationProps {
    selectedEvent: AvailabilityProduct;
    selectedTime: number;
}

const PackageBookingDateStartDuration = ({
    selectedEvent,
    selectedTime,
}: PackageBookingDateStartDurationProps) => {
    const { t } = useTranslation('product');
    const { control } = useFormContext<PackageBookingFormValues>();
    const selectedFormTime = useWatch({
        control,
        name: 'selectedTime',
    });

    const start = selectedEvent.events[0].event?.plan.items[0].start;
    const end = selectedEvent.events.at(-1)?.event?.plan?.items?.at(-1)?.end;

    const duration = getEventDurationLabel(start, end);

    const time = +selectedFormTime || selectedTime;

    return (
        <Stack
            sx={{
                grow: 2,
                pl: 0,
                pr: 3,
                pt: '10px',
                pb: 2,
            }}
            direction="row"
            justifyContent="space-evenly"
            gap={1}
        >
            <SquareCard
                title={t('Date')}
                value={format(+time, 'dd MMM yyyy')}
                Icon={CalendarMonthIcon}
                sx={{ maxHeight: '80px' }}
            />
            <SquareCard
                title={t('Start')}
                value={format(+time, 'HH:mm')}
                Icon={AccessTimeIcon}
                sx={{ maxHeight: '80px' }}
                count={3}
            />
            <SquareCard
                title={t('Duration')}
                value={duration}
                Icon={AccessTimeIcon}
                sx={{ maxHeight: '80px' }}
                count={3}
            />
        </Stack>
    );
};

export default PackageBookingDateStartDuration;
